module.exports = __webpack_public_path__ + "static/img/logo.9dc6fc6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo.jpg
// module id = iywV
// module chunks = 1